import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { InduccionProgramarModel } from 'src/app/models/induccion/InduccionModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { InduccionBaseModel } from 'src/app/models/queries/inducciones/InduccionBaseModel';
import { FilterSolicitudPersonaPendienteInduccionModel } from 'src/app/models/queries/solicitudes/solicitud-persona/FilterSolicitudPersonaPendienteInduccion';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { InduccionService } from 'src/app/services/induccion/induccion.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { SolicitudPersonaService } from 'src/app/services/solicitud-persona/solicitud-persona.service';
import { InduccionProgramarDialogComponent } from '../induccion-programar-dialog/induccion-programar-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';


@Component({
  selector: 'app-induccion-programacion-lista',
  templateUrl: './induccion-programacion-lista.component.html',
  styleUrls: ['./induccion-programacion-lista.component.css']
})
export class InduccionProgramacionListaComponent implements OnInit {
  //  modelFilter: IFilterInduccionModel;
  modelFilter: FilterSolicitudPersonaPendienteInduccionModel;

  modelListaInducciones: InduccionBaseModel[];
  resultsLength = 0;
  currentPage = 0;
  listaSedes: ISedeModel[] = new Array<SedeModel>();

  @ViewChild('paginator') paginator!: MatPaginator;

  displayedColumns: string[] = [   
    'compania',
    'trabajador',
    'nroDocumentoIdentidad',
    'fecha_aprobacion',
    'estado',
    'sede',
    'solicitante',
    'contratista',
    'codigo_solicitud',
    'acciones',
  ];

  constructor(
    private induccionService: InduccionService,
    private solicitudPersonaService: SolicitudPersonaService,
    public dialog: MatDialog,
    private sedeService: SedeService,
    private storage: StorageService
  ) {
    this.modelFilter = new FilterSolicitudPersonaPendienteInduccionModel();
    this.modelFilter.pageSize = 30;

    this.modelListaInducciones = new Array<InduccionBaseModel>();
  }

  ngOnInit(): void {
    const filterSede: IFilterSedeModel = new FilterSedeModel();

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });

    this.search();
  }

  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.solicitudPersonaService
      .getAllPendienteInduccion(this.modelFilter)
      .subscribe((data: SearchResultModel<InduccionBaseModel[]>) => {
        this.modelListaInducciones = data.items;
        this.modelListaInducciones.forEach((data) => {
          data.programarInduccion = false;
        });
        this.resultsLength = data.total;
      });
  }

  search() {
    this.modelFilter.page = 1;

    this.solicitudPersonaService
      .getAllPendienteInduccion(this.modelFilter).subscribe((data) => {
        this.modelListaInducciones = data.items;
        this.modelListaInducciones.forEach((data) => {
          data.programarInduccion = false;
        });
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  programar() {
    let programacionInducciones = new InduccionProgramarModel();
    programacionInducciones.listaInducciones = this.modelListaInducciones.filter(p => p.programarInduccion).map(a => a.idInduccion);
    const dialogRef = this.dialog.open(InduccionProgramarDialogComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: programacionInducciones
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.search();
    });
  }


  addDays(currentDate: Date, days: number): Date {
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  esInvalido(): boolean {
    return this.modelListaInducciones.filter(p => p.programarInduccion).length == 0;
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.solicitudPersonaService.getAllPendienteInduccionToExport(this.modelFilter).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `pendiente-induccion-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }
}
